/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SingleDocumentResponseViewModel } from './SingleDocumentResponseViewModel';
import {
    SingleDocumentResponseViewModelFromJSON,
    SingleDocumentResponseViewModelFromJSONTyped,
    SingleDocumentResponseViewModelToJSON,
} from './SingleDocumentResponseViewModel';

/**
 * 
 * @export
 * @interface QuoteAndApplicationDocumentViewModel
 */
export interface QuoteAndApplicationDocumentViewModel {
    /**
     * 
     * @type {SingleDocumentResponseViewModel}
     * @memberof QuoteAndApplicationDocumentViewModel
     */
    documentResponse: SingleDocumentResponseViewModel;
    /**
     * 
     * @type {number}
     * @memberof QuoteAndApplicationDocumentViewModel
     */
    fileSize?: number;
    /**
     * 
     * @type {Date}
     * @memberof QuoteAndApplicationDocumentViewModel
     */
    dateDownloaded?: Date;
}

/**
 * Check if a given object implements the QuoteAndApplicationDocumentViewModel interface.
 */
export function instanceOfQuoteAndApplicationDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentResponse" in value;

    return isInstance;
}

export function QuoteAndApplicationDocumentViewModelFromJSON(json: any): QuoteAndApplicationDocumentViewModel {
    return QuoteAndApplicationDocumentViewModelFromJSONTyped(json, false);
}

export function QuoteAndApplicationDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteAndApplicationDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentResponse': SingleDocumentResponseViewModelFromJSON(json['DocumentResponse']),
        'fileSize': !exists(json, 'FileSize') ? undefined : json['FileSize'],
        'dateDownloaded': !exists(json, 'DateDownloaded') ? undefined : (new Date(json['DateDownloaded'])),
    };
}

export function QuoteAndApplicationDocumentViewModelToJSON(value?: QuoteAndApplicationDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'DocumentResponse': SingleDocumentResponseViewModelToJSON(value.documentResponse),
        'FileSize': value.fileSize,
        'DateDownloaded': value.dateDownloaded === undefined ? undefined : (value.dateDownloaded.toISOString()),
    };
}

